// base app

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Nav from "./components/nav";
import Home from "./pages/home";
import About from "./pages/about";
import Contact from "./pages/contact";
import Watch from "./pages/watch";
import Thanks from "./pages/thanks";
import NotFound from "./pages/notfound";
import Shows from "./pages/shows";
import Listen from "./pages/listen";
import Play from "./pages/play";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Nav />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/watch" element={<Watch />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/thanks" element={<Thanks />} />
          <Route path="/shows" element={<Shows />} />
          <Route path="/listen" element={<Listen />} />
          <Route path="/play" element={<Play />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}